import * as React from 'react';
import * as styles from './styles.css';

import { MoreFiltersBtn } from './components/MoreFiltersBtn';
import { IPreciseFiltersProps } from './types';
import { AllFiltersModal } from './components/AllFiltersModal';

type TPreciseFiltersProps = IPreciseFiltersProps & {
  ref?: React.Ref<HTMLDivElement>;
};

export function PreciseFilters(props: TPreciseFiltersProps): React.JSX.Element {
  const { mainBtnCount, onMoreFiltersButtonClick, moreFiltersText, ref } = props;

  return (
    <React.Fragment>
      <div ref={ref} data-testid="precise_filters" className={styles['precise-filters']}>
        <div>
          <MoreFiltersBtn buttonText={moreFiltersText} onClick={onMoreFiltersButtonClick} count={mainBtnCount} />
        </div>
      </div>
      <AllFiltersModal {...props} />
    </React.Fragment>
  );
}
